/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useParams } from 'js/lib/useRouter';

import { Grid, Link, Typography2, breakpoints } from '@coursera/cds-core';

import EnrollStep from 'bundles/degree-description/components/modules/fcnd/EnrollStep';
import Container from 'bundles/degree-description/components/shared/Container';
import { useDegreeDescriptionPageTheme } from 'bundles/degree-description/degreeDescriptionPageTheme';
import { useDegreeDescriptionEventingContext } from 'bundles/degree-description/providers/DegreeDescriptionEventingProvider';
import { appendUtmParametersToApplicationLink } from 'bundles/expression-of-interest/utils/util';
import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';
import getDegreesConversionCopy from 'bundles/stackability-common/copy/degreesConversionCopy';

const styles = {
  background: css`
    padding: var(--cds-spacing-600) 0;
  `,

  image: () => css`
    ${breakpoints.up('md')} {
      max-width: 400px;
    }

    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
    }
  `,
  hideOnMobile: () => css`
    ${breakpoints.down('sm')} {
      display: none;
    }
  `,
  hideOnDesktop: () => css`
    ${breakpoints.up('md')} {
      display: none;
    }
  `,
};

export const FCNDModule = () => {
  const theme = useDegreeDescriptionPageTheme();
  const { useGetViewPageSectionRef } = useDegreeDescriptionEventingContext();
  const { slug } = useParams();
  // @ts-expect-error TS2345 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  const fcndModuleCopy = getDegreesConversionCopy().stackabilityModuleRefresh.fcndModuleCopy(slug);
  const pageSectionTrackingRef = useGetViewPageSectionRef('for_credit_non_degree');

  return (
    <div css={styles.background} ref={pageSectionTrackingRef}>
      <Container>
        <Grid container direction="column" spacing={24}>
          <Grid item container direction="column" spacing={24} sm={12} md={8}>
            <Grid item>
              <Typography2 variant="titleSmall" css={theme.mobileFontSizeStyle?.header} component="h2">
                {fcndModuleCopy.title}
              </Typography2>
            </Grid>

            <Grid item>
              <Typography2 component="p">
                {fcndModuleCopy.description}
                {fcndModuleCopy.ctaLink && (
                  <Link
                    href={appendUtmParametersToApplicationLink(fcndModuleCopy.ctaLink)}
                    target="_blank"
                    variant="quiet"
                    typographyVariant="subtitleMedium"
                    css={{ marginLeft: 'var(--cds-spacing-50)' }}
                    component={TrackedLink2}
                    trackingName="upsells_fcnd"
                  >
                    {fcndModuleCopy.ctaLabel}
                  </Link>
                )}
              </Typography2>
            </Grid>
          </Grid>

          <Grid item container spacing={16}>
            {fcndModuleCopy.enrollSteps.map((step) => (
              <EnrollStep key={step.number} {...step} />
            ))}
          </Grid>

          <Grid item>
            <Typography2 component="p">{fcndModuleCopy.disclaimer}</Typography2>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default React.memo(FCNDModule);
